import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const Add = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Add",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2a10 10 0 0 1 0 20m.4-10.5h4.5v1h-4.5V17h-1v-4.5H6.9v-1h4.5V7h1zM12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

